module.exports = __webpack_public_path__ + "img/purpose_purchase.32c26643.svg";